import PropTypes from 'prop-types'
import React from 'react'

import { firebase } from 'data'

const withAuth = (Component) => {
  class WithAuth extends React.Component {
    state = {
      user: null,
      loading: true,
    }

    componentWillMount() {
      this.removeListener = firebase.auth.onAuthStateChanged((user) => {
        user ? ( // eslint-disable-line no-unused-expressions
          this.setState({
            user,
            loading: false,
          })
        ) : (
          this.setState({
            user: null,
            loading: false,
          })
        )
      })
    }

    componentWillUnmount() {
      this.removeListener()
    }

    render() {
      const { loading, user } = this.state

      return (
        <Component {...this.props} loading={loading} user={user} />
      )
    }
  }

  WithAuth.propTypes = {
    user: PropTypes.object,
    loading: PropTypes.bool,
  }

  return WithAuth
}

export default withAuth



// WEBPACK FOOTER //
// ./src/components/withAuth/withAuth.js